import React, { useEffect, useRef } from "react";
import Select from "react-select";

import { getLanguageCode } from "../../../../../../../selectors/generic";
import { CustomError } from "./CustomError";

const formatOptionLabel = ({ value, label }) => {
  return (
    <>
      <div className={`flag flag--${value?.toLowerCase()}`}></div>
      {label}
    </>
  );
};
export const CustomSelectDropdown = ({ schema, uiSchema, onChange, formData, isPhone }) => {
  const options = schema.Enum.map(({ value, title }) => ({ value, label: title }));
  const defaultOption = !isPhone ? options[0] : options.find(({ value }) => value.toLowerCase() === getLanguageCode().substring(3).toLowerCase());
  const filteredOptions = options.filter(({ value }) => value !== "");
  const selectedOption = formData ? options.find(option => option.value.toLowerCase() === formData.toLowerCase()) : defaultOption;
  const selectRef = useRef();

  useEffect(() => {
    if (isPhone) {
      onChange(selectedOption.value);
    }
  }, []);

  return (
    <div className={"custom-select custom-field"}>
      {schema.title && <label className={"control-field"}>{schema.title}</label>}
      <Select
        ref={selectRef}
        defaultValue={defaultOption}
        value={selectedOption}
        isSearchable={true}
        options={filteredOptions}
        onChange={option => {
          onChange(option.value);
          selectRef.current.select.blur();
        }}
        onMenuClose={() => selectRef.current.select.blur()}
        formatOptionLabel={isPhone ? formatOptionLabel : undefined}
        classNamePrefix={"custom-select"}
        className={!isPhone && selectedOption.value === defaultOption.value ? "default" : ""}
      />
      <CustomError schema={schema} uiSchema={uiSchema}/>
    </div>
  );
};

export const PhoneDropdown = (props) => <CustomSelectDropdown {...props} isPhone={true}/>;
